import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import RegionBranchMultipleSelect from 'component/branch/RegionBranchMultipleSelectNew'
import HierarchySelect from 'component/hierarchy/HierarchySelectNew'
import NewDateIntervalInput from 'component/DateIntervalInput/NewDateIntevalInput'
import Select from 'component/Select/Select'
import CloseIconSVG from 'component/svgComponents/close'

class SideFilterForm extends React.Component {
  static propTypes = {
    closeFilter: PropTypes.func.isRequired,
    onSubmit: PropTypes.func.isRequired,
    translate: PropTypes.func.isRequired,
    auth: PropTypes.object.isRequired,
    show: PropTypes.bool,
    isUserMatriz: PropTypes.bool,
    missionsSelectBranchs: PropTypes.array
  }

  state = {
    values: {
      branchs: [],
      sections: [],
      period: [],
      status: '',
    },
  }

  handleChange = (name, value) => {
    const { values } = this.state

    values[name] = value

    this.setState({ values })
  }

  getStatusOptions() {
    const { translate } = this.props

    const options = [
      {
        label: translate('select.all'),
        value: '',
      },
      {
        label: translate('irc.active'),
        value: '1',
      },
      {
        label: translate('irc.inactive'),
        value: '0',
      },
    ]

    return options
  }

  isBtnDisabled() {
    const { values } = this.state
    let disabled = false

    const toValidate = ['branchs', 'period']

    for (const field of toValidate) {
      if (
        (Array.isArray(values[field]) && values[field].length === 0) ||
        !values[field]
      ) {
        disabled = true
      }
    }

    return disabled
  }

  handleSubmit = () => {
    const { onSubmit } = this.props
    const { values } = this.state

    const newValues = { ...values }

    let branchs = []
    for (const b of newValues.branchs || []) {
      if (b.idBranches) {
        branchs.push(...b.idBranches)
        branchs.push(b.value)
      } else {
        branchs.push(b.value)
        branchs.push(b.idRegion)
      }
    }
    branchs = branchs.filter((b, p) => branchs.indexOf(b) === p)

    const sections = []
    for (const s of newValues.sections || []) {
      if (s.sectionId) {
        sections.push(s.sectionId)
      }
    }

    newValues.dtBegin =
      newValues.period.length > 0 ? newValues.period[0].format() : ''
    newValues.dtEnd =
      newValues.period.length > 0 ? newValues.period[1].format() : ''
    newValues.branchs = branchs
    newValues.sections = sections

    delete newValues.period

    onSubmit(newValues)
  }

  render() {
    const {
      translate,
      auth: { user },
      closeFilter,
      show,
      isUserMatriz,
      missionsSelectBranchs
    } = this.props

    const { values } = this.state

   

    return (
      <div
        className={`right-filter-container irc-side-filter ${
          !show ? 'hidden' : ''
        }`}
      >
        <CloseIconSVG className="right-filter-svg" onClick={closeFilter} />
        <h3 className='margin-bottom-triple'>
          <strong>{translate('mobile.filter')}</strong>
        </h3>

        <div className='w-100'>
          <RegionBranchMultipleSelect
            required
            name='branchs'
            label={translate('irc.store')}
            placeholder={translate('irc.choose-store')}
            user={user}
            translate={translate}
            onChange={(e) => this.handleChange('branchs', e.target.value)}
            value={ !isUserMatriz ? ( missionsSelectBranchs.includes(user.title) ? values.branchs : [{ value: user.locationCode.padStart(4, '0') }] ): values.branchs}
            disabled={!isUserMatriz}
          />
        </div>

        <div className='w-100'>
          <HierarchySelect
            required
            label={translate('irc.section')}
            placeholder={translate('irc.choose-section')}
            name={'sections'}
            query={{ level: 2 }}
            user={user}
            translate={translate}
            value={values.sections}
            fill
            isMulti
            onChange={(e) => this.handleChange('sections', e)}
          />
        </div>

        <div className='w-100'>
          <NewDateIntervalInput
            required
            user={user}
            label={translate('field.period.hint')}
            name={'period'}
            t={translate}
            onChange={(e) => this.handleChange('period', e)}
            maxLimitDay={user.isLdapInManager ? false : parseInt(user.reportLimitDaysFilter, 10)}
          />
        </div>

        <div className='w-100'>
          <Select
            required
            label={translate('irc.status')}
            disableSearch
            options={this.getStatusOptions()}
            onChange={(e) => this.handleChange('status', e.value)}
            value={this.getStatusOptions().find(({ value }) => value === values.status)}
            validateValue={e => Boolean(e)}
          />
        </div>

        <button
          className='btn btn-primary button-full'
          onClick={this.handleSubmit}
          disabled={this.isBtnDisabled()}
          type='button'
        >
          {translate('btn.filter')}
        </button>
      </div>
    )
  }
}

const mapStateToProps = ({ auth }) => ({
  isUserMatriz: auth.isUserMatriz,
  user: auth.user
})

export default connect(mapStateToProps)(SideFilterForm)

export { SideFilterForm }
